import { faBorderAll, faTableSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import clsx from 'clsx'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { AlignmentDropdown } from './AlignmentDropdown'
import { CellColorPicker } from './CellColorPicker'
import {
  editorBubbleMenuSeparator,
  editorButtonToggle,
  editorButtonToggleActive,
  editorTableMenuDanger
} from './EditorInput.css'
import { TableColumnDropdown } from './TableColumnDropdown'
import { TableRowDropdown } from './TableRowDropdown'
import { VerticalAlignDropdown } from './VerticalAlignDropdown'

type TableBubbleMenuProps = {
  editor: Editor
  isTableBordered: boolean
  onToggleBorders: () => void
}

export const TableBubbleMenu = ({
  editor,
  isTableBordered,
  onToggleBorders
}: TableBubbleMenuProps) => (
  <>
    <TableColumnDropdown editor={editor} />
    <TableRowDropdown editor={editor} />
    <div className={editorBubbleMenuSeparator} />
    <AlignmentDropdown editor={editor} />
    <VerticalAlignDropdown editor={editor} />
    <div className={editorBubbleMenuSeparator} />
    <CellColorPicker editor={editor} />
    <div className={editorBubbleMenuSeparator} />
    <Tooltip
      direction="bottom"
      text={isTableBordered ? 'Masquer les bordures' : 'Afficher les bordures'}
      asChild
    >
      <button
        type="button"
        className={clsx(
          editorButtonToggle,
          isTableBordered && editorButtonToggleActive
        )}
        onClick={onToggleBorders}
      >
        <FontAwesomeIcon icon={faBorderAll} />
      </button>
    </Tooltip>
    <div className={editorBubbleMenuSeparator} />
    <Tooltip direction="bottom" text="Supprimer le tableau" asChild>
      <button
        type="button"
        className={clsx(editorButtonToggle, editorTableMenuDanger)}
        onClick={() => editor.chain().focus().deleteTable().run()}
      >
        <FontAwesomeIcon icon={faTableSlash} />
      </button>
    </Tooltip>
  </>
)
